import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../providers/auth.service';
import { SessionService } from '../../providers/session.service';
import { User } from '../../models/user';
import { SmsAbstractAppPage } from '../sms-abstract-app-page';
import { faUser, faSignOut }  from '@fortawesome/fontawesome-pro-regular';

@Component({
  standalone: false,
  selector: 'app-logged-in',
  templateUrl: './logged-in.component.html',
styleUrls:  ['./logged-in.component.css']
})
export class LoggedInComponent extends SmsAbstractAppPage implements OnInit {

	user: User;
	faUser = faUser;
	faSignOut = faSignOut;

  constructor(private authService: AuthService, private router: Router, private sessionService: SessionService) {
  	super();
  }

  ngOnInit() {
  	this.sessionService.user$.subscribe(user => {
  		this.user = user;
  	});
  }


  handleLogout() {
    this.authService.logout().then(result => {
        this.router.navigate(['login']);
      }).catch(error => {
        this.handleError(error);
      });
  }

}
